import { render, staticRenderFns } from "./DeleteQueueItemDialog.vue?vue&type=template&id=25ffb349"
import script from "./DeleteQueueItemDialog.vue?vue&type=script&lang=js"
export * from "./DeleteQueueItemDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports